// extracted by mini-css-extract-plugin
export default {"container":"SkillGage_container__GZWw6","skill":"SkillGage_skill__ExPTV","skillName":"SkillGage_skillName__hZCx1"};